import React, { type ReactElement } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";

const HeroSection = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="container text-center">
      <h1 className="mx-auto mb-2 text-xl md:text-3xl">
        {t("best_travel_esim")}
      </h1>
      <p className="mx-auto mb-6 text-lg font-semibold md:text-xl">
        {t("connect_like_a_local")}
      </p>
      <div className="mb-2 inline-block transition duration-300 hover:scale-105">
        <img
          src="/images/award_winner_home_page_icon.avif"
          width={600}
          loading="eager"
          alt="Best Travel Sim: Award Winner"
        />
      </div>
    </div>
  );
};

export default HeroSection;
